import { render, staticRenderFns } from "./RegionAdd.vue?vue&type=template&id=3eec09da&scoped=true"
import script from "./RegionAdd.vue?vue&type=script&lang=js"
export * from "./RegionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec09da",
  null
  
)

export default component.exports